<template lang="pug">
form(@submit.prevent="onSubmit")
  modal(active title="Filtrar compras" @close="$router.back()")
    div(slot="modal-body")
      .columns
        .column.col-8.col-sm-12
          form-group(label="Título")
            input.form-input(v-model="filter.title" placeholder="Título")
        .column.col-4.col-sm-12
          form-group(label="Tipo de produto")
            select.form-select(v-model="filter.productType")
              option(:value="null")
              option(v-for="label, value in productTypes" :value="value") {{ label }}
      .divider.text-center(data-content="Período")
      .columns
        .column.col-6.col-sm-12
          form-group(label="Publicado a partir de")
            datepicker(v-model="filter.minPublishDate")
        .column.col-6.col-sm-12
          form-group(label="Publicado até")
            datepicker(v-model="filter.maxPublishDate" fullDay)
    div(slot="modal-footer")
      .text-right
        router-link.btn.btn-link.mr-2(v-if="Boolean($route.query.q)" :to="{ name: 'indications.list' }" replace)
          i.fas.fa-times
          |  Limpar filtros
        button.btn.btn-primary
          i.fas.fa-filter
          |  Filtrar
</template>

<script>
export default {
  data() {
    return {
      filter: { minPublishDate: null, maxPublishDate: null },
    }
  },
  computed: {
    productTypes() {
      return {
        book: 'Livros',
        magazine: 'Revistas',
        video: 'Playlists de vídeo',
      }
    },
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: 'indications.list',
        query: { q: this.filter },
      })
    },
  },
  created() {
    const { q = {} } = this.$route.query
    this.filter = q
  },
}
</script>
